import { QueryParamKey } from '@ddt-web/url';

import { DecoratorUtil } from '../utils/decorator.util';


export function InjectQueryParam(queryParamKey: QueryParamKey, options?: { separator?: string }): PropertyDecorator {
	const PREFIX = '__$$';

	return (target: any, propertyKey: string) => {

		const getQueryParamValue = () => {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const queryParamValue = urlSearchParams.get(queryParamKey);
			return queryParamValue;
		};

		Object.defineProperty(target, propertyKey, {
			set: () => {
				target[PREFIX + propertyKey] = DecoratorUtil.convertValueToType(target, propertyKey, getQueryParamValue(), options);
			},
			get: () => {
				target[PREFIX + propertyKey] = DecoratorUtil.convertValueToType(target, propertyKey, getQueryParamValue(), options);
				return target[PREFIX + propertyKey];
			},
			enumerable: true,
			configurable: true
		});
	};
}
